import { Component, Inject, Optional } from '@angular/core';
import { MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NodeSelectorDialogBoxComponent} from 'app/main/apps/estructura-jerarquica/dialog/node-selector-dialog-box.component';
import { RiesgoService } from 'app/main/services/riesgo.service';
import { EstructuraJerarquicaService } from 'app/main/services/estructura-jerarquica.service';
import { Riesgo } from 'app/main/models/riesgo.model';
import { EstructuraJerarquica } from 'app/main/models/estructura-jerarquica.model';
import { MedidaDeContingencia } from 'app/main/models/medida-de-contingencia.model';
import {TranslateService} from '@ngx-translate/core';


@Component({
  selector: 'app-dialog-box',
  templateUrl: './add-medidas-de-contingencia-dialog-box.component.html',
  styleUrls: ['./add-medidas-de-contingencia-dialog-box.component.scss']
})
export class AddMedidaDeContingenciaDialogBoxComponent {

  action: string;
  data: MedidaDeContingencia = {id:null,nodo:null,estructura:null,riesgo:null,
                            responsable:null,medida:'',referente:null};

  estructura: EstructuraJerarquica = null;
  riesgos: Riesgo[] = [];


  constructor(
    public dialog: MatDialog,
    public riesgosService : RiesgoService,
    public translate: TranslateService,
    public serviceEstructuraJerarquica: EstructuraJerarquicaService,
    public dialogRef: MatDialogRef<AddMedidaDeContingenciaDialogBoxComponent>,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public dataIn: any) {

      this.action = dataIn.action;
      this.estructura = dataIn.estructura;
      this.riesgos = dataIn.riesgos;
      if(this.action=='Update' || this.action=='Delete' || this.action=='View'){
        this.data = dataIn.obj;
      }

      if(this.data.nodo==null){
        this.data.estructura = dataIn.estructura;
        this.data.nodo = dataIn.nodo;
      }
  }

  doAction(): void{

    this.dialogRef.close({event: this.action, data: this.data});
  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }


  openDialog(): void {

    const dialogRef = this.dialog.open(NodeSelectorDialogBoxComponent, {
      width: '100%',
      data: {estructura:this.estructura,action:'ADD'},
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.data.nodo = result.data.nodo;
      this.data.estructura = result.data.estructura;
      this.data.referente = null;

    });
  }

  compareObjects(o1: any, o2: any): boolean {

    var equals = false;
    if(o1!=null && o2!=null && typeof o1 === 'object' &&  typeof o2 === 'object' && 'id' in o1 && 'id' in o2 && o1.id === o2.id){
      equals = true;
    }else{
      equals = (o1 == o2)? true:false;
    }

    return equals;
  }


  ngOnInit(): void {

  }

}
